import {
  Activity,
  ArrowUpDown,
  Bell,
  Box,
  Bug,
  CircleCheck,
  CircleDot,
  CircleQuestionMark,
  CircleX,
  Cog,
  Container,
  Cpu,
  Fan,
  FilePlus,
  FolderOpen,
  Gauge,
  Inbox,
  Info,
  Lightbulb,
  MonitorPlay,
  MoveHorizontal,
  Network,
  OctagonAlert,
  Package,
  PackageX,
  PanelBottom,
  PanelLeft,
  PanelRight,
  Pause,
  PencilRuler,
  Play,
  Radar,
  Redo2,
  RotateCcw,
  Save,
  Server,
  Settings,
  SlidersHorizontal,
  SquareTerminal,
  StepForward,
  ToggleLeft,
  TriangleAlert,
  Undo2,
  Waves,
  Waypoints,
  Workflow,
  X,
  Square,
  Sun,
  Moon,
  ZoomIn,
  ZoomOut,
  Maximize2,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * Central icon registry (Phase 1 §20). Components refer to icons by name; no component embeds
 * its own SVG. Device definitions use the same names through `DeviceDefinition.meta.icon`.
 */
export const ICONS = {
  // Application / toolbar
  app: Cpu,
  new: FilePlus,
  open: FolderOpen,
  save: Save,
  undo: Undo2,
  redo: Redo2,
  run: Play,
  pause: Pause,
  step: StepForward,
  reset: RotateCcw,
  stop: Square,
  settings: Settings,
  help: CircleQuestionMark,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  'zoom-reset': Maximize2,
  // Modes
  'mode-design': PencilRuler,
  'mode-program': Workflow,
  'mode-workshop': Zap,
  'mode-simulation': MonitorPlay,
  'mode-monitor': Activity,
  'mode-debug': Bug,
  'theme-light': Sun,
  'theme-dark': Moon,
  // Layout
  'panel-left': PanelLeft,
  'panel-right': PanelRight,
  'panel-bottom': PanelBottom,
  developer: SquareTerminal,
  // Feedback
  close: X,
  info: Info,
  success: CircleCheck,
  warning: TriangleAlert,
  error: CircleX,
  empty: Inbox,
  // Devices (keyed by DeviceType)
  button: CircleDot,
  switch: ToggleLeft,
  'emergency-stop': OctagonAlert,
  sensor: Radar,
  'jam-sensor': PackageX,
  'level-sensor': Waves,
  lamp: Lightbulb,
  motor: Cog,
  buzzer: Bell,
  conveyor: MoveHorizontal,
  cylinder: ArrowUpDown,
  valve: Waypoints,
  tank: Container,
  pump: Fan,
  mixer: RotateCcw,
  product: Package,
  'pid-controller': SlidersHorizontal,
  'modbus-server': Server,
  'modbus-client': Network,
  gauge: Gauge,
  fan: Fan,
  pipe: Waypoints,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

const isIconName = (name: string): name is IconName => name in ICONS;

/** Resolves an icon name coming from a domain layer; unknown names fall back to a neutral box. */
export function resolveIcon(name: string): LucideIcon {
  return isIconName(name) ? ICONS[name] : Box;
}
